import type { ReactNode } from 'react';

export const symbol_stack_hexagon: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m584-405 121-69q6.75-3.71 10.88-10.77Q720-491.83 720-500v-138q0-8.17-4.12-15.23-4.13-7.06-10.88-10.77l-121-69q-6.68-4-14.84-4T554-733l-121 69q-6.75 3.71-10.87 10.77Q418-646.17 418-638v138q0 8.17 4.13 15.23 4.12 7.06 10.87 10.77l121 69q6.68 4 14.84 4t15.16-4ZM318-258q-24 0-42-18t-18-42v-502q0-24 18-42t42-18h502q24 0 42 18t18 42v502q0 24-18 42t-42 18H318Zm0-60h502v-502H318v502Zm251-251ZM206-140Zm7 59q-25 3-44.5-11.5T146-132L82-630q-3-25 12.5-45t40.5-23l32-3q14-2 23 7.14 9 9.15 9 22.86 0 12-7.58 19.92-7.59 7.92-18.42 10.08l-31 3 65 498 569-69q12-2 22 6t12 20.39q2 12.39-5.5 21.5T784-150L213-81Zm356-384-91-53v-102l91-53 91 53v102l-91 53Z"
		/>
	</svg>
);
